/**
 * @typedef {import('../../definitions').TimeTableRecord} TimeTableRecord
 * @typedef {import('../../definitions').BigCalendarEvent} BigCalendarEvent
 */

/**
 * @typedef {(timeTables: TimeTableRecord[]) => BigCalendarEvent[]} DigestTimeTableList
 */

/**
 * @typedef {Object} TimeTablesDataDigestHook
 * @property {DigestTimeTableList} digestTimeTableList
 */

/**
 * Hook that process academic data digestion.
 * @return {TimeTablesDataDigestHook}
 */
const useTimeTablesDataDigest = () => {
  /**
   * Transform STT record representation into Big Calendar Event.
   * @type {DigestTimeTableList}
   * @param {TimeTableRecord[]} timeTables
   * @return {BigCalendarEvent[]}
   */
  const digestTimeTableList = (timeTables) => {
    if(!timeTables) {
      return []
    }

    return timeTables.map((item) => {
      return {
        id: item.id,
        title: item.title,
        start: new Date(item.startDate),
        end: new Date(item.endDate),
        allDay: false,
      }
    })
  }

  return {
    digestTimeTableList
  }
}

export default useTimeTablesDataDigest
